import { render, staticRenderFns } from "./GrupoBet.vue?vue&type=template&id=8ac90e70&scoped=true"
import script from "./GrupoBet.vue?vue&type=script&lang=js"
export * from "./GrupoBet.vue?vue&type=script&lang=js"
import style0 from "./GrupoBet.vue?vue&type=style&index=0&id=8ac90e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac90e70",
  null
  
)

export default component.exports